export const WEB_LINKS = [
  { labelKey: 'strengthen.webLinks.resume', type: 're', value: 'Resume' },
  { labelKey: 'strengthen.webLinks.portfolio', type: 'po', value: 'Portfolio' },
  { labelKey: 'strengthen.webLinks.website', type: 'pw', value: 'Website' },
  { labelKey: 'strengthen.webLinks.linkedin', type: 'ln', value: 'Linkedin' },
];

export const QUESTION_KEYS = [
  'current_employer',
  'current_location',
  'current_title',
  'joining_date',
  'license_available',
  'diversity_hire',
  'attention_required',
];

export const PROGRESS_VALUES = [
  'current_employer',
  'current_location',
  'current_title',
  'joining_date',
  'license_available',
  'skills',
  'diversity_hire',
  'resume_file_links',
  'links_json',
];

export const PROGRESS_QUESTIONS = {
  current_employer: 'strengthen.progressQuestions.currentEmployer',
  current_location: 'strengthen.progressQuestions.currentLocation',
  current_title: 'strengthen.progressQuestions.currentTitle',
  joining_date: 'strengthen.progressQuestions.joiningDate',
  license_available: 'strengthen.progressQuestions.licenseAvailable',
  skills: 'strengthen.progressQuestions.skills',
  files: 'strengthen.progressQuestions.files',
  diversity_hire: 'strengthen.progressQuestions.diversityHire',
  links_json: 'strengthen.progressQuestions.linksJson',
};
